module.exports = __webpack_public_path__ + "media/images/MR_SwtcL-84315556.svg";